import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ItemBreakdown from '../../../common/RefundModal/components/ItemBreakdown';
import { CELL_WIDTH_LED, CELL_WIDTH_STATUS } from '../constants';
import Date from '../../../common/date';
import Time from '../../../common/Time';
import { t } from '../../../../modules/infra/i18n';

const SummaryRowExpanded = ({ item }) => (
  <div className="u-bg-white u-pb- u-pr-">
    <div
      className="epsilon dark-mode-white"
      style={{
        marginLeft: CELL_WIDTH_LED,
        marginRight: CELL_WIDTH_STATUS,
      }}
    >
      <div className={classnames('o-flexbox', { 'o-flexbox--justify-end': !item.appointmentCancelTime })}>
        <div>
          <b display-if={item.appointmentCancelTime}>
            {t('register:summary_row_expanded.date_of_cancellation')} <Date>{item.appointmentCancelTime}</Date> @{' '}
            <Time>{item.appointmentCancelTime}</Time>
          </b>
        </div>
        <div>
          <ItemBreakdown item={item} />
        </div>
      </div>
    </div>
  </div>
);
SummaryRowExpanded.propTypes = {
  item: PropTypes.shape({
    barber: PropTypes.object,
    items: PropTypes.string,
    cost: PropTypes.number,
    tax: PropTypes.number,
    appointmentCancelTime: PropTypes.string,
  }).isRequired,
};

export default SummaryRowExpanded;
